<div class="header-container">
  <div class="safe-area"></div>
  @if (!showGameScore() && !showGameReplay() && showNavbar()) {
    <div class="navbar">
      <app-navbar
        [gameName]="gameName"
        [gameId]="gameId"
        [tabs]="tabs"
        [balance]="balance"
        (closeClicked)="onCloseClicked()"
        (tabSelected)="onTabSelected($event)"
      />
    </div>
  }
  @if (showGameScore()) {
    <div class="game-score">
      <app-game-score
        [gameId]="gameId"
        [gameName]="gameScoreService.gameName()"
        [gameBehaviorType]="gameScoreService.gameBehaviorType()"
        [gameInterfaceState]="displayGameInterfaceState()"
        [score]="gameScoreService.score().toLocaleString()"
        [reward]="gameScoreService.formattedReward()"
        [countdown]="gameScoreService.countdown()"
        [tournamentId]="gameScoreService.tournamentId()"
        (backClicked)="onBackClicked()"
        (closeClicked)="onCloseClicked()"
        (cheatSheetClicked)="onCheatSheetClicked()"
      />
    </div>
  }
  @if (showGameReplay()) {
    <div class="game-replay">
      <app-game-replay
        [gameId]="gameId"
        [gameInterfaceState]="gameScoreService.gameInterfaceState()"
        [reward]="gameScoreService.formattedReward()"
        [roomId]="gameScoreService.roomId()"
        (closeClicked)="onCloseReplayClicked()"
      />
    </div>
  }
</div>
